import { IconButton, Tooltip } from '@material-ui/core';

import { useApplicationButtonIconStyles } from '@/components/modules/Application/hooks/useApplicationButtonIconStyles';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';

export const EditButton = ({ handleClick }: { handleClick: () => void }) => {
  const { size, color, buttonStyles } = useApplicationButtonIconStyles();

  return (
    <Tooltip title={<Text tId={'EDIT_ITEM'} />}>
      <IconButton onClick={handleClick} style={buttonStyles}>
        <Icon size={size} color={color}>
          edit
        </Icon>
      </IconButton>
    </Tooltip>
  );
};
